import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

const phoneNumberInstance = PhoneNumberUtil.getInstance();

export const formatPhoneNumber = (prefix, phone) => {
  try {
    const parsedPhone = phoneNumberInstance.parse(`+${prefix}${phone}`);
    const isValid = phoneNumberInstance.isValidNumber(parsedPhone);
    const format = phoneNumberInstance.format(parsedPhone, PhoneNumberFormat.INTERNATIONAL);
    if (!isValid) throw new Error('Invalid phone number');
    return format;
  } catch (e) {
    return null;
  }
};
